"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __exports_1 = require("../../../__exports");
/* istanbul ignore next */
var DropdownSection = function (props) { return (React.createElement(__exports_1.default.DropdownList, { showLabel: false, label: props.dropdownLabel, onChange: props.onDropdownSelect, items: props.options || [], value: props.selectedValue })); };
exports.default = DropdownSection;
//# sourceMappingURL=DropdownSection.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/filter-sections/build/control/components/DropdownSection/DropdownSection.js
// module id = 920
// module chunks = 0